<div class="bg-white rounded-lg shadow-lg p-6 h-full">
  <div class="mb-6 flex justify-between items-center">
    <div class="flex items-center gap-3">
      <h2 class="text-2xl font-bold">Buchungen ({{ getFilteredBookings().length }})</h2>
      <span *ngIf="unreadMessagesCount > 0" 
            class="bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full animate-pulse">
        {{ unreadMessagesCount }} neue Nachricht{{ unreadMessagesCount !== 1 ? 'en' : '' }}
      </span>
    </div>
    <div class="space-x-2 flex flex-wrap">
      <button 
        *ngFor="let f of ['all', 'new', 'confirmed', 'cancelled']"
        (click)="bookingFilter = f"
        [class]="'px-3 py-2 rounded-lg font-semibold text-sm transition ' + (bookingFilter === f ? 'bg-brand-accent text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300')">
        {{ f === 'all' ? 'Alle' : (f === 'new' ? 'Neu' : f === 'confirmed' ? 'Bestätigt' : 'Storniert') }}
      </button>
    </div>
  </div>



  <div *ngIf="bookingsLoading" class="text-center text-gray-600 py-8">
    <p class="text-lg">Laden...</p>
  </div>

  <div *ngIf="!bookingsLoading && getFilteredBookings().length === 0" class="text-center text-gray-600 py-8">
    <p class="text-lg">Keine Buchungen gefunden</p>
  </div>

  <div class="space-y-3 max-h-[calc(100vh-250px)] overflow-y-auto">
    <div 
      *ngFor="let booking of getFilteredBookings()"
      (click)="onSelectBooking(booking)"
      [class]="'p-4 rounded-lg cursor-pointer border-2 transition ' + (selectedBookingId === booking.id ? 'border-brand-accent bg-brand-accent bg-opacity-10' : 'border-gray-200 hover:border-brand-accent hover:bg-gray-50')">
      
      <div class="flex justify-between items-start gap-4">
        <div class="flex-1">
          <h3 class="font-bold text-lg">{{ booking.customerName }}</h3>
          <p class="text-sm text-gray-600">{{ booking.email }}</p>
          <div class="mt-2 text-xs text-gray-600 space-y-1">
            <p><strong>Zeitraum:</strong> {{ booking.startDate | date:'dd.MM.yyyy' }} - {{ booking.endDate | date:'dd.MM.yyyy' }}</p>
            <p><strong>Dauer:</strong> {{ booking.durationDays }} Tage</p>
            <p *ngIf="booking.includes360Branding" class="text-brand-accent"><strong>🎨 360° Branding</strong></p>
          </div>
        </div>
        <div class="flex flex-col items-end gap-2">
          <div class="flex items-center gap-2">
            <!-- Unread Message Badge -->
            <span *ngIf="hasUnreadMessages(booking.id!)" 
                  class="bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full flex items-center gap-1 animate-pulse">
              <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
              </svg>
              {{ getUnreadCount(booking.id!) }}
            </span>
            
            <span [class]="'px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap ' + getStatusColor(booking.status)">
              {{ getStatusString(booking.status) | titlecase }}
            </span>
          </div>
          <p class="text-sm font-bold text-brand-accent">€{{ booking.price | number:'1.2-2' }}</p>
          <button
            (click)="openDeleteModal(booking, $event)"
            class="text-xs font-semibold text-red-600 hover:text-red-700 hover:underline">
            Löschen
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete Booking Modal -->
<div *ngIf="showDeleteModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" (click)="closeDeleteModal()">
  <div class="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6" (click)="$event.stopPropagation()">
    <h3 class="text-2xl font-bold mb-4">Buchung endgültig löschen?</h3>
    <p class="text-gray-600 mb-4">
      Diese Aktion löscht den Auftrag dauerhaft und kann nicht rückgängig gemacht werden.
    </p>
    <div class="bg-gray-50 p-4 rounded-lg mb-6">
      <p class="text-sm text-gray-600">Auftrag</p>
      <p class="font-bold">{{ bookingToDelete?.customerName }}</p>
      <p class="text-xs text-gray-500">{{ bookingToDelete?.email }}</p>
    </div>
    <div class="flex gap-3">
      <button
        (click)="closeDeleteModal()"
        [disabled]="deletingBooking"
        class="flex-1 px-4 py-2 border border-gray-300 rounded hover:bg-gray-50 transition disabled:opacity-50">
        Abbrechen
      </button>
      <button
        (click)="confirmDeleteBooking()"
        [disabled]="deletingBooking"
        class="flex-1 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition disabled:opacity-50">
        {{ deletingBooking ? 'Löschen...' : 'Ja, löschen' }}
      </button>
    </div>
  </div>
</div>
